import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";
import { ProgressBar } from "./ProgressBarComponent";
import { ParentDetailsComponent } from "./ParentDetailsComponent";
import { GeneralEnquiryComponent } from "./GeneralEnquiryComponent";
import { ChildDetailsComponent } from "./ChildDetailsComponent";
import { TourDayComponent } from "./TourDayComponent";
import { ReviewFormComponent } from "./ReviewFormComponent";
import { HomeFormComponent } from "./HomeFormComponent";
import { LiveTourBookingComponent } from "./LiveTourBookingComponent";
import { EmbeddedFormComponent } from "./EmbeddedFormComponent";
import { PromoFormHeader } from "./PromoFormHeader";


export const FormComponent = () => {

	const {
		state,
		GoBack,
		Next,
		SubmitEnquiry,
		Exit
	} = React.useContext(EnquiryContext)

	const buildTitle = (currentStep: number, requiredSteps: number, selectionId: number, selectionLabel: string) => {
		//console.log(`currentStep: ${currentStep}, requiredSteps: ${requiredSteps}, selectionId: ${selectionId}, selectionLabel: '${selectionLabel}'`)
		 
		let title = null;

		if (currentStep == 0) {
			title = "Enquiry"
		}
		else if (currentStep > 0 && currentStep <= requiredSteps) {
			title = selectionLabel
		}
		else if (currentStep > requiredSteps) {
			if (selectionId == 4) {
				title = "Review Live Tour Booking"
			}
			else {
				title = "Review Enquiry"
			}
		}

		return title;
	}

	//const promoBanner = {
	//	url: "promo-girl-enquiry-mobile.png",
	//	aspectWidth: "aspect-w-9",
	//	aspectHeight: "aspect-h-10",
	//	bgColor: "bg-skin-eggplant",
	//	objectStyle: "object-contain",
	//	objectPosition: "object-bottom"
	//}

	const noEmbeddedWidth = state.currentStep <= 1 ? "lg:w-1/2" : "lg:w-3/5"

	return (
		<React.Fragment>
			<div className={`relative w-full h-auto py-10 px-6 lg:py-4 lg:px-6 xl:py-10 xl:px-10 ${state.initialSelection?.id > 4 ? "" : noEmbeddedWidth}`}>
				<div id="enquiry-title-div" className=" relative text-center font-bold text-3xl text-skin-heading mb-6">
					{(!!state.model?.closeUrl && state.model?.closeUrl) != "" &&
						<span className="absolute right-0 top-2 cursor-pointer text-skin-heading font-normal text-xl" onClick={() => Exit()}>x</span>
					}
					{(state.currentStep > 1 || (state.currentStep == 1 && state.model?.enquiryCentreDetailsList[0].isLiveTourBookingAvailable && state.model?.enquiryCentreDetailsList.length == 1)) &&
						<span className="absolute left-0 top-4 cursor-pointer font-normal" onClick={() => GoBack()}><img src="/img/icons/chevron-back-navy.svg" /></span>
					}
					{buildTitle(state.currentStep, state.requiredSteps, state.initialSelection?.id, state.initialSelection?.label)}
				</div>

				
				{state.model?.freeChildCarePromo &&
					<PromoFormHeader />
				}
				

				<div className="bg-skin-site-header pl-8 p-4 mb-8 rounded-lg text-base font-semibold text-skin-heading">
					<ul className="list-outside list-disc">
						{state.model?.enquiryCentreDetailsList.map(centre => {
							return <li>{centre.centreName}</li>
						})}
					</ul>
				</div>

				{/*FORM AREA*/}
				<div id="enquiry-form-area">

					{/*Submit Error*/}
					<div>
						{(!!state.submitError && state.currentFormComponent == "reviewForm") &&
							<div className="bg-red-200 border border-red-400 text-red-400 p-6 rounded mb-6">
								{state.submitError.message}
							</div>
						}
					</div>
					{/*Live Tour Booking session expired error*/}
					<div>
						{(!!state.liveTourBookingSessionExpired) &&
							<div className="bg-red-200 border border-red-400 text-red-400 p-6 rounded mb-6">
								Your Live Tour Booking session has expired. Please click <button onClick={() => window.location.reload()} className="underline">here</button> to start again.
							</div>
						}
					</div>
					 
					{/*Progress Bar*/}
					{(state.initialSelection?.id == 2 && state.currentStep > 0 && state.currentStep <= state.requiredSteps) &&
						<div className="flex flex-row items-center mb-4">
							<span className="font-semibold text-base-15 min-w-24">
								STEP {state.currentStep} of {state.requiredSteps}
							</span>
							<ProgressBar />
						</div>
					}

					{state.currentStep == 0 &&
						<HomeFormComponent />
					}

					{/*GENERAL ENQUIRY*/}
					{state.initialSelection?.id == 1 && state.currentStep == 1 &&
						<GeneralEnquiryComponent />
					}

					{/*PREFFERED TOUR DAYS*/}
					{/*{state.currentStep == 2 && state.initialSelection?.id == 2 &&*/}
					{/*	<TourDayComponent />*/}
					{/*}*/}


					{/* Live Tour Booking pages start */}

					{state.initialSelection?.id == 4 && state.currentStep == 1 &&
						<ChildDetailsComponent />
					}

					{state.initialSelection?.id == 4 && state.currentStep == 2 &&
						<ParentDetailsComponent />
					}

					{state.initialSelection?.id == 4 && state.currentStep == 3 &&
						<LiveTourBookingComponent />
					}

					{/* Live Tour Booking pages end */}

					{/* Embedded Tour Booking */}
					{state.initialSelection?.id == 5 && state.currentStep == 1 &&
						<EmbeddedFormComponent type="Tour" />
					}

					{/* Embedded Waitlist */}
					{state.initialSelection?.id == 6 && state.currentStep == 1 &&
						<EmbeddedFormComponent type="Waitlist" />
					}

					{state.currentStep > state.requiredSteps &&
						<ReviewFormComponent />
					}

				</div>

				{state.currentStep > state.requiredSteps &&
					<div className="pb-4 w-full text-center ">
						<button onClick={() => SubmitEnquiry()} className="cta-primary px-14 button disabled:opacity-50 mb-10" disabled={!state.canSubmit || state.loading}>
							{state.loading && <span className="flex flex-row items-center gap-2"><img src="/img/white-spinner.svg" alt="Spinner white dots circle" /><span>Sending...</span></span>}
							{!state.loading && <span>Submit</span>}
						</button>
					</div>
				}

				{(state.currentStep <= state.requiredSteps && state.currentStep > 0 && state.currentFormComponent != "embeddedForm") &&
					<React.Fragment>
						{/*Background for absolutely positioned next button*/}
						<div className="h-20"></div>
						<div className="absolute pb-10 bottom-10 mt-1 mb-1 left-0 w-full text-center">
							<button onClick={() => Next()} className="cta-primary px-14 button">Next</button>
						</div>
					</React.Fragment>
				}

			</div>
		</React.Fragment>
	);

}